import { useEffect, useState } from "react";
import { Lock } from "lucide-react";

import { SESSION_STORAGE_HYDRATED_EVENT } from "../../hooks/use-navigation";
import {
    isPayrollProcessLocked,
    PAYROLL_PROCESS_LOCK_MESSAGE,
} from "../../utils/customConfigSession";
import { cn } from "../../utils/tailwindUtils";

/**
 * Read-only notice when payroll process lock is ON.
 * Blocks OT / allowance / deduction changes while payroll is being processed.
 */
const PayrollProcessLockNotice = ({ className, message = PAYROLL_PROCESS_LOCK_MESSAGE }) => {
    const [locked, setLocked] = useState(isPayrollProcessLocked);

    useEffect(() => {
        const sync = () => setLocked(isPayrollProcessLocked());
        window.addEventListener(SESSION_STORAGE_HYDRATED_EVENT, sync);
        return () => window.removeEventListener(SESSION_STORAGE_HYDRATED_EVENT, sync);
    }, []);

    if (!locked) return null;

    return (
        <div
            className={cn(
                "rounded-xl border border-amber-300/80 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800/60 px-4 py-3 flex items-start gap-3",
                className,
            )}
            role="status"
            aria-live="polite"
        >
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-200/80 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200">
                <Lock className="h-4 w-4" />
            </span>
            <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                    Payroll process is locked
                </p>
                <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-300 mt-0.5 leading-relaxed">
                    {message}
                </p>
            </div>
        </div>
    );
};

export default PayrollProcessLockNotice;
